const _ = require("lodash");

const createCatalog = (plans, addons, useChatbot, licences, period, plan_code, myLicenses) => {
  console.log(
    "createCatalog (plans, addons, useChatbot, licences, period, plan_code, myLicenses)",
    plans,
    addons,
    useChatbot,
    licences,
    period,
    plan_code,
    myLicenses
  );
  // Select plan
  const myPlan = _.find(plans, item => {
    if (item.plan.period_unit === period && item.plan.id.startsWith(plan_code + "_")) return true;
    return false;
  });

  // List of ids
  const myAddonIds = [];
  _.each(myPlan.plan.applicable_addons, item => {
    myAddonIds.push(item.id);
  });

  // Filter addons
  const myAddons = _.filter(addons.addons, item => _.includes(myAddonIds, item.addon.id));

  // return basket structure
  const newCatalog = {
    plan: myPlan.plan,
    addons: myAddons.map(item => item.addon),
    plan_code: plan_code
  };
  console.log("new Catalog", newCatalog);
  return newCatalog;
};

const getPlanInfo = item => {
  if (!item) return "";

  let separator = "";
  let planInfo = "";
  if (item.cf_chatbot_websites > 0 || item.cf_interactions > 0 || item.cf_user_licences > 0) {
    let separator = "( ";
    if (item.cf_interactions > 0) {
      planInfo += separator + item.cf_interactions.toLocaleString() + " interactions";
      separator = ", ";
    }
    if (item.cf_user_licences > 0) {
      planInfo += separator + item.cf_user_licences.toLocaleString() + " user licenses";
      separator = ", ";
    }
    if (item.cf_chatbot_websites > 0) {
      planInfo += separator + item.cf_chatbot_websites + " chatbot websites";
      separator = ", ";
    }
    planInfo += " )";
  }
  return planInfo;
};

const getMainItem = catalog => {
  const planInfo = getPlanInfo(catalog.plan);
  return {
    id: catalog.plan.id,
    count: 1,
    name: catalog.plan.invoice_name,
    price: catalog.plan.price,
    total: catalog.plan.price,
    description: catalog.plan.description,
    planInfo: planInfo
  };
};

const getAddonItems = (basket, addlicences, useChatbot, myLicenses) => {
  const intAddLicenses = parseInt(addlicences);
  console.log(
    "getAddonItems (basket, addlicences, useChatbot, myLicenses)",
    basket,
    intAddLicenses,
    useChatbot,
    myLicenses
  );
  const items = [];
  let addlicencesMore = 0;
  if (useChatbot) {
    let addon = basket.addons.find(item => item.cf_chatbot_websites > 0 && item.cf_user_licences > 0);
    if (addon) {
      if (myLicenses && myLicenses.users && myLicenses.users[basket.plan_code]) {
        const myCount = myLicenses.users[basket.plan_code].limitSum;
        console.log("MYCOUNT", myCount);
        let requiredUsers = addon.cf_user_licences;
        addlicencesMore = requiredUsers - myCount;
        if (addlicencesMore < 0) addlicencesMore = 0;
        addon = basket.addons.find(item => item.cf_chatbot_websites > 0 && item.cf_user_licences === 0);
      }
      if (addon) {
        const planInfo = getPlanInfo(addon);
        items.push({
          id: addon.id,
          count: 1,
          name: addon.invoice_name ? addon.invoice_name : addon.name,
          price: addon.price,
          total: addon.price,
          description: addon.description,
          planInfo: planInfo
        });
      }
    }
  }
  console.log("addlicencesMore", addlicencesMore);
  if (intAddLicenses + addlicencesMore > 0) {
    const addon = basket.addons.find(item => item.cf_user_licences === 1 && item.cf_chatbot_websites === 0);
    if (addon) {
      const planInfo = getPlanInfo(addon);
      items.push({
        id: addon.id,
        count: intAddLicenses + addlicencesMore,
        name: addon.invoice_name ? addon.invoice_name : addon.name,
        price: addon.price,
        total: addon.price * (intAddLicenses + addlicencesMore),
        description: addon.description,
        planInfo: planInfo
      });
    }
  }
  return items;
};

const getFiksedLicenses = (basket, useChatbot, myLicenses) => {
  console.log("getFiksedLicenses (basket, useChatbot, myLicenses)", basket, useChatbot, myLicenses);
  if (!basket || !basket.plan || !basket.plan.cf_user_licences) return 0;
  let licences = basket.plan.cf_user_licences;
  if (useChatbot) {
    const addon = basket.addons.find(item => item.cf_chatbot_websites > 0 && item.cf_user_licences > 0);
    if (addon) {
      licences += addon.cf_user_licences;
      if (myLicenses && myLicenses.users && myLicenses.users[basket.plan_code]) {
        const myCount = myLicenses.users[basket.plan_code].limitSum;
        if (myCount >= licences) {
          licences = 1;
        } else {
          licences -= myCount;
        }
      }
    }
  }
  return licences;
};

module.exports = { createCatalog, getPlanInfo, getMainItem, getAddonItems, getFiksedLicenses };
